import { useEffect, useState } from 'react';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';
import { RICHTEXT_TEMPLATE_EVENT, onReadRichTextTemplate } from '../../../AppTemplateResolved';
import { onResolveRichTextTemplate } from '../../RichText/_RichTextTemplates';

/*
    🔥 CAMPO DE TEXTO ENRIQUECIDO

    No implementa nada: resuelve cuál de los cinco editores usar y lo
    monta. Cambiás el id en la config y toda la app cambia de editor.

    Se puede forzar uno puntual con templateId, para casos donde un
    campo necesite otro editor que el resto de la app.
*/

export const FieldRichText = ({
    id, label, hint, error,
    value, onChange, placeholder = 'Escribí acá…',
    templateId = null, minHeight = 160,
    isRequired = false, isDisabled = false,
    span = 2, ...rest
}) => {

    const [useActiveId, setActiveId] = useState(() => templateId ?? onReadRichTextTemplate());

    // 🔥 Escucha el cambio desde el panel de desarrollo
    useEffect(() => {

        if (templateId) return;   // si se forzó uno, el panel no manda

        const onChangeTemplate = (event) => setActiveId(event.detail?.id);

        window.addEventListener(RICHTEXT_TEMPLATE_EVENT, onChangeTemplate);
        return () => window.removeEventListener(RICHTEXT_TEMPLATE_EVENT, onChangeTemplate);

    }, [templateId]);

    const TEMPLATE = onResolveRichTextTemplate(templateId ?? useActiveId);

    const EditorComponent = TEMPLATE.component;

    /*
        ⚠️ Quill llama a onChange con el HTML pelado; markdown y los
           demás con un evento. Normalizamos acá para que la vista
           siempre reciba lo mismo.
    */
    const onHandleChange = (next) => {

        if (next?.target !== undefined) return onChange?.(next.target.value);

        onChange?.(next);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span}
            isRequired={isRequired} isDisabled={isDisabled}
            hint={hint ?? TEMPLATE.description} >

            <EditorComponent
                value={value ?? ''}
                onChange={onHandleChange}
                placeholder={placeholder}
                isDisabled={isDisabled}
                minHeight={minHeight}
                {...TEMPLATE.props}
                {...rest}
            />

        </FieldShell>
    );
};
